import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
import { useReducedMotion } from "../../../hooks/useReducedMotion";
/**
 * Loaded on first render rather than at import time.
 *
 * `lottie-web` builds a canvas while its module evaluates, which happy-dom has no
 * implementation for — a static import here would therefore throw for every
 * test that so much as imports the package barrel, whether or not it renders
 * an icon.
 */ const LottiePlayer = /*#__PURE__*/ React.lazy(async ()=>{
    const { Player } = await import("@lottiefiles/react-lottie-player");
    return {
        default: Player
    };
});
/** Served by the host app from its public assets. */ const DEFAULT_BLIKSY_ICON_SRC = "/assets/bliksy-icon.json";
/** Bliksy icon using a Lottie animation. Static by default, animated when opted in. */ function BliksyIcon({ size = 28, animated = false, src = DEFAULT_BLIKSY_ICON_SRC, className }) {
    const reducedMotion = useReducedMotion();
    const shouldAnimate = animated && !reducedMotion;
    return /*#__PURE__*/ _jsx("div", {
        role: "img",
        "aria-label": "Bliksy",
        children: /*#__PURE__*/ _jsx(React.Suspense, {
            fallback: /*#__PURE__*/ _jsx("div", {
                style: {
                    width: size,
                    height: size
                }
            }),
            children: /*#__PURE__*/ _jsx(LottiePlayer, {
                src: src,
                background: "transparent",
                speed: 1,
                loop: shouldAnimate,
                autoplay: shouldAnimate,
                keepLastFrame: true,
                className: cn("rounded-full", className),
                style: {
                    width: size,
                    height: size
                }
            })
        })
    });
}
export { BliksyIcon };

//# sourceMappingURL=bliksy-icon.js.map